import React from "react";
import { Button, ClickAwayListener, Modal } from "@mui/material";
import Lottie from "react-lottie";
import ErrorFile from "assets/lottie/error_file.json";
import { Ptag } from "components/core";

function ErrorModal({ open, handleClose, downloadErrorFile }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: ErrorFile,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <section
        style={{
          display: "grid",
          placeItems: "center",
          height: "100vh",
        }}
      >
        <ClickAwayListener onClickAway={() => handleClose()}>
          <section
            style={{
              background: "white",
              width: "80vh",
              padding: "120px",
              borderRadius: "14px",
            }}
          >
            <Lottie
              options={defaultOptions}
              height={120}
              width={120}
              style={{ opacity: "1" }}
              isClickToPauseDisabled
            />
            <Ptag
              fontSize="20px"
              textAlign="center"
              fontWeight="600"
              marginBottom="18px"
            >
              Ooops!
            </Ptag>
            <Ptag fontSize="16px" fontWeight="400" textAlign="center">
              Employee data upload failed due to data discrepancy. <br /> Please
              check the files for errors!
            </Ptag>
            <footer
              style={{
                display: "grid",
                placeItems: "center",
              }}
            >
              <Button
                variant="text"
                // onClick={downloadErrorFile}
                onClick={() => {
                  downloadErrorFile();
                  handleClose();
                  // window.location.reload();
                }}
                style={{
                  textTransform: "none",
                  color: "#FF0E0E",
                  fontFamily: "Inter",
                  marginTop: "24px",
                  textDecoration: "underline",
                  fontSize: "14px",
                }}
              >
                Download the Error File
              </Button>
            </footer>
          </section>
        </ClickAwayListener>
      </section>
    </Modal>
  );
}

export default ErrorModal;
